import { Asset } from '@/api/generatedApi';
import { getAssetFileName, getAssetFolderDirectory } from '@/utils/assets';
import { dateFormat } from '@/utils/format';

export const getAssetValue = (asset: Asset, rowKey: string): string => {
  switch (rowKey) {
    case 'name': {
      return getAssetFileName(asset);
    }
    case 'created': {
      return dateFormat(asset.createdAt);
    }
    case 'createdBy': {
      return asset.creator?.email || '';
    }
    case 'folder': {
      return getAssetFolderDirectory(asset) || 'none';
    }
    default: {
      if (rowKey.startsWith('metadata_')) {
        const metadataKey = rowKey.replace('metadata_', '');
        return String(asset.metadata?.[metadataKey] ?? '');
      }
      return '';
    }
  }
};
